import { getListSlice, initialListState } from '../getListSlice';
import { IListState } from '../types';
import { fetchSubscriptionPlans } from './asyncThunk';
import {
  ISubscriptionPlan,
  TSubscriptionPlanSlug,
} from 'src/api/base/Subscriptions/types';
import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { RootState } from '../../index';

export type ISubscriptionPlansState = IListState<ISubscriptionPlan>;

const initialState: ISubscriptionPlansState = { ...initialListState };

const subscriptionPlans = getListSlice({
  moduleName: 'subscriptionPlans',
  fetchDataThunk: fetchSubscriptionPlans,
  initialState,
});

export const subscriptionPlansReducer = subscriptionPlans.reducer;

const selectSelf = (state: RootState) => state.subscriptionPlans;
export const subscriptionPlansNamesSelector = createDraftSafeSelector(
  selectSelf,
  (state) =>
    state.data.reduce<Record<TSubscriptionPlanSlug, string>>(
      (acc, item) => ({
        ...acc,
        [item.slug]: item.name,
      }),
      {},
    ),
);
